/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useRef, useState} from "react";
import {ShieldExclamationIcon} from "@heroicons/react/24/solid";
import clsx from "clsx";
import {ArrowRightIcon, CheckBadgeIcon} from "@heroicons/react/24/outline";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import BookingLoginAction from "store/bookingLogin/BookingLoginAction";
import {useDispatch} from "useDispatch";
import {closeModal} from "helpers/actions";
import BookingLoginReservationButton
    from "pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/BookingLoginReservationButton";
import {ReservationDriver} from "types/entities/ReservationDriver";
import {PackagesCartItem} from "types/entities/PackagesCartItem";
import {InfoMessageType, setInfoMessage} from "components/InfoMessage";
import ReservationButtonInner
    from "pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/ReservationButtonInner";
import BookingLoginTableRow from "pages/Front/Booking/BookingLogin/components/BookingLoginTableRow";
import TableRowColumn from "pages/Front/Booking/BookingLogin/components/TableRowColumn";
import ReservationDetailInput
    from "pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/ReservationDetailInput";

export interface ReservationCustomersInvitationsFormInputs {
    email: string;
    reservation_id: number;
    packages_cart_item_id: number;
}

interface BookingLoginCustomersInvitationsModalProps {
    reservation_id: number;
    item: PackagesCartItem;
    onResult: (reservationDriver: ReservationDriver) => void;
}

const AccessTicketDriverInvitation = (props: BookingLoginCustomersInvitationsModalProps) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [messageStatus, setMessageStatus] = useState<number | null>(null);
    const successMessageRef = useRef<HTMLDivElement>(null);
    const ReservationCustomersInvitationsSchema = yup.object().shape({
        email: yup.string().required("Put the emails under yourself."),
        reservation_id: yup.number().required(),
        packages_cart_item_id: yup.number().required(),
    });

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm<ReservationCustomersInvitationsFormInputs>({
        resolver: yupResolver(ReservationCustomersInvitationsSchema),
        defaultValues: {
            email: "",
            packages_cart_item_id: props.item.id,
            reservation_id: props.reservation_id,
        },
    });

    const onErrorHandler = (dataErrors: any) => {
        console.log("onErrorHandler", dataErrors);
    };

    const onSubmitHandler = (data: ReservationCustomersInvitationsFormInputs) => {
        console.log("onSubmitHandler", data);
        if (isLoading) {
            return true;
        }

        setIsLoading(true);

        return dispatch(BookingLoginAction.fetchReservationInvitation(data))
            .then(response => {
                // return setSubmittedSuccess(true);
                if (response.reservationDriver) {
                    props.onResult(response.reservationDriver);
                }
                console.log("onSubmitHandler - response", response);

                dispatch(BookingLoginAction.fetchReservationDetail(props.reservation_id));
                if (successMessageRef?.current) {
                    successMessageRef.current.scrollIntoView({behavior: "smooth"});
                }
                return setMessageStatus(200);
            })
            .catch(err => {
                setInfoMessage(err, InfoMessageType.ERROR);
                // toast.error(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClose = () => {
        dispatch(closeModal());
    };

    return (
        // <CardComponent className={"AccessTicketDriverInvitation w-full border border-gray-200 text-xs md:text-base  flex flex-col gap-y-3 p-4"}>
        <div className={"AccessTicketDriverInvitation w-full overflow-auto rounded-2xl shadow-sm border-2 border-gray-100"}>
            {/*<div className={"flex w-full"}>*/}
            {/*    <form autoComplete={"off"} className={"w-full"} onSubmit={handleSubmit(onSubmitHandler, onErrorHandler)}>*/}
            {/*        <input {...register("reservation_id")} type={"hidden"} />*/}
            {/*        <input {...register("packages_cart_item_id")} type={"hidden"} />*/}

            {/*        <div>*/}
            {/*            <label className={clsx("font-medium text-xxs md:text-sm  mb-1 flex", errors?.["emails"] && "text-red-500")} htmlFor={"label-emails"}>*/}
            {/*                <span>{t("E-mail")}</span>*/}
            {/*                <em className={"text-red-500"}>*</em>*/}
            {/*            </label>*/}
            {/*            <input*/}
            {/*                className={clsx("w-full p-3 rounded-md border-gray-200 border", errors?.["emails"] && "border-red-500")}*/}
            {/*                id={"label-emails"}*/}
            {/*                {...register("email")}*/}
            {/*                placeholder={t("example1@gmail.com")}*/}
            {/*            />*/}
            {/*            {errors?.["emails"]?.message && (*/}
            {/*                <div className={"text-red-500 mt-1 flex flex-row items-center shrink-0"}>*/}
            {/*                    <ExclamationCircleIcon className={"min-w-[18px] min-h-[18px] w-[18px] h-[18px] mr-0.5"} />*/}
            {/*                    <T>{errors?.["emails"]?.message}</T>*/}
            {/*                </div>*/}
            {/*            )}*/}
            {/*        </div>*/}
            {/*    </form>*/}
            {/*</div>*/}
            {/*<div*/}
            {/*    ref={successMessageRef}*/}
            {/*    className={clsx(*/}
            {/*        "items-center justify-center font-medium px-3 py-3 border-t bg-green-50 text-center",*/}
            {/*        messageStatus === 200 && "text-green-500",*/}
            {/*        messageStatus !== 200 && messageStatus !== null && "text-red-500",*/}
            {/*        messageStatus ? "flex" : "hidden"*/}
            {/*    )}*/}
            {/*>*/}
            {/*    {messageStatus === 200 && (*/}
            {/*        <>*/}
            {/*            <CheckBadgeIcon className={"grow-0 shrink-0 self-start w-6 h-6 text-green-500"} />*/}
            {/*            <span className={"ml-1"}>{t("All invitations have been sent successfully.")}</span>*/}
            {/*        </>*/}
            {/*    )}*/}
            {/*    {messageStatus === 404 && (*/}
            {/*        <>*/}
            {/*            <ShieldExclamationIcon className={"grow-0 shrink-0 self-start w-7 h-6 text-green-500"} />*/}
            {/*            <span className={"ml-1"}>{t("Error, please contact support.")}</span>*/}
            {/*        </>*/}
            {/*    )}*/}
            {/*</div>*/}
            <form autoComplete={"off"} className={"w-full"} onSubmit={handleSubmit(onSubmitHandler, onErrorHandler)}>
                <BookingLoginTableRow className={clsx("grid-cols-1 gap-4 xl:gap-y-4 xl:gap-x-8 px-6 xl:px-10 py-5 lg:py-6")}>

                    <input {...register("reservation_id")} type={"hidden"} />
                    <input {...register("packages_cart_item_id")} type={"hidden"} />

                    <TableRowColumn className={"CheckEmailInput w-full"}>
                        {/*<label className={clsx("font-medium text-xxs md:text-sm  mb-1 flex", errors?.["emails"] && "text-red-500")} htmlFor={"label-emails"}>*/}
                        {/*    <span>{t("E-mail")}</span>*/}
                        {/*    <em className={"text-red-500"}>*</em>*/}
                        {/*</label>*/}
                        {/*<input*/}
                        {/*    className={clsx("w-full p-3 rounded-md border-gray-200 border", errors?.["emails"] && "border-red-500")}*/}
                        {/*    id={"label-emails"}*/}
                        {/*    {...register("email")}*/}
                        {/*    placeholder={t("example1@gmail.com")}*/}
                        {/*/>*/}
                        {/*{errors?.["emails"]?.message && (*/}
                        {/*    <div className={"text-red-500 mt-1 flex flex-row items-center shrink-0"}>*/}
                        {/*        <ExclamationCircleIcon className={"min-w-[18px] min-h-[18px] w-[18px] h-[18px] mr-0.5"} />*/}
                        {/*        <T>{errors?.["emails"]?.message}</T>*/}
                        {/*    </div>*/}
                        {/*)}*/}

                        <ReservationDetailInput
                            errors={errors}
                            label={t("Email")}
                            name={"email"}
                            register={register}
                            required={true}
                            placeholder={t("example1@gmail.com")}
                            id={"label-emails"}
                        />

                    </TableRowColumn>
                    <TableRowColumn className={"w-full mt-2"}>
                        <BookingLoginReservationButton
                            className={"w-full"}
                            type={"submit"}
                            disabled={isLoading}
                            onClick={handleSubmit(onSubmitHandler, onErrorHandler)}
                        >
                            <ReservationButtonInner>
                                <span>{t("Invite")}</span>
                                <ArrowRightIcon className={"stroke-2 size-4"} />
                            </ReservationButtonInner>
                        </BookingLoginReservationButton>
                    </TableRowColumn>
                    {messageStatus && (
                        <TableRowColumn className={"w-full"}>
                            <div
                                ref={successMessageRef}
                                className={clsx(
                                    "items-center justify-center font-medium px-3 py-3 border-t bg-green-50 text-center",
                                    messageStatus === 200 && "text-green-500",
                                    messageStatus !== 200 && messageStatus !== null && "text-red-500",
                                    messageStatus ? "flex" : "hidden"
                                )}
                            >
                                {messageStatus === 200 && (
                                    <>
                                        <CheckBadgeIcon className={"grow-0 shrink-0 self-start w-6 h-6 text-green-500"} />
                                        <span className={"ml-1"}>{t("All invitations have been sent successfully.")}</span>
                                    </>
                                )}
                                {messageStatus === 404 && (
                                    <>
                                        <ShieldExclamationIcon className={"grow-0 shrink-0 self-start w-7 h-6 text-green-500"} />
                                        <span className={"ml-1"}>{t("Error, please contact support.")}</span>
                                    </>
                                )}
                            </div>
                        </TableRowColumn>
                    )}
                </BookingLoginTableRow>
            </form>
        </div>
    );
};

export default AccessTicketDriverInvitation;
